{
  "languageChanged": "Language changed to Romanian",
  "breadCrumb_Forsiden": "Forside",
  "language_norwegian": "Norsk",
  "language_english": "English",
  "language_sami": "Sámi",
  "language_nynorsk": "Nynorsk",
  "language_lithuanian": "Lietuviškai",
  "language_polish": "Polski",
  "language_russian": "Русский",
  "language_romanian": "Română",
  "language_ukrainian": "Українська",
  "language_french": "Français"
}
